import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { passengersFormsSelector } from '@/models/forms/selectors';
import { formsActions } from '@/models/forms';
import { MIN_PASSENGERS_AMOUNT } from '@/libs/constants';
import { useIsMobileViewInsuranceForm } from '../../hooks';
import { useStyles } from './styles';
import { PassengerBirthdayDesktop } from './PassengerBirthdayDesktop';
import { PassengerBirthdayMobile } from './PassengerBirthdayMobile';
export const PassengerBirthday = memo(({ _uuid, appearance, birthday, errorMessage, }) => {
    const passengers = useSelector(passengersFormsSelector);
    const passengersAmount = passengers.length;
    const classes = useStyles();
    const dispatch = useDispatch();
    const isMobileFormView = useIsMobileViewInsuranceForm();
    const withDeleteButton = passengersAmount > MIN_PASSENGERS_AMOUNT;
    const handleRemovePassenger = () => dispatch(formsActions.removePassenger(_uuid));
    const component = useMemo(() => {
        const props = {
            _uuid,
            withButton: withDeleteButton,
            onDelete: handleRemovePassenger,
            appearance,
            birthday,
            errorMessage,
        };
        return isMobileFormView ? (_jsx(PassengerBirthdayMobile, { ...props })) : (_jsx(PassengerBirthdayDesktop, { ...props }));
    }, [
        isMobileFormView,
        withDeleteButton,
        handleRemovePassenger,
        appearance,
        _uuid,
        birthday,
        errorMessage,
    ]);
    return (_jsx("div", { className: classes.birthdayWrapper, children: component }, "birthday"));
});
